import AuditService from '../../services/AuditService'

const state = () => ({
    loadingAudit: false,
    audit_logs: [],
    audit_actions: [],
    total: 0,
    pages: 0,
    page: 1,
})

const mutations = {
    SET_AUDIT_LOGS: (state, payload) => {
        if (payload.pageNumber == 1) {
            state.audit_logs = payload.itens
        } else {
            state.audit_logs = [...state.audit_logs, ...payload.itens]
        }
        state.page = payload.pageNumber
        state.pages = payload.pages
        state.total = payload.total
    },
    SET_AUDIT_ACTIONS: (state, payload) => {
        state.audit_actions = payload
    },
    SET_LOADING_AUDIT: (state, payload) => {
        state.loadingAudit = payload
    },
}

const actions = {
    async fetchAuditLogs({ commit }, { keyword = '', pageNumber = 1, action = '', AdmId = '', dateFrom = '', dateTo = '' } = {}) {
        try {
            commit('SET_LOADING_AUDIT', true)
            const response = await AuditService.get({ keyword, pageNumber, action, AdmId, dateFrom, dateTo });
            commit('SET_AUDIT_LOGS', response.data)
        } catch (error) {
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response?.data?.message || 'Falha ao carregar a auditoria.'
            });
        } finally {
            commit('SET_LOADING_AUDIT', false)
        }
    },
    async fetchAuditActions({ commit }) {
        try {
            const response = await AuditService.getActions();
            commit('SET_AUDIT_ACTIONS', response.data.itens || [])
        } catch (error) {
            // silencioso: o filtro de ações é acessório
            console.error('Falha ao carregar ações de auditoria:', error);
        }
    },
}

const getters = {
    getAuditLogs: state => state.audit_logs,
    getAuditActions: state => state.audit_actions,
    getLoadingAudit: state => state.loadingAudit,
}

export default {
    state,
    getters,
    mutations,
    actions
}
